"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

const useDrip = (initialValue = false, ref) => {
  const [dripVisible, setDripVisible] = (0, _react.useState)(initialValue);
  const [dripX, setDripX] = (0, _react.useState)(0);
  const [dripY, setDripY] = (0, _react.useState)(0);

  const dripCompletedHandle = () => {
    setDripVisible(false);
    setDripX(0);
    setDripY(0);
  };

  const clickHandler = event => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setDripVisible(true);
    setDripX(event.clientX - rect.left);
    setDripY(event.clientY - rect.top);
  };

  return {
    visible: dripVisible,
    x: dripX,
    y: dripY,
    onClick: clickHandler,
    onCompleted: dripCompletedHandle
  };
};

var _default = useDrip;
exports.default = _default;
module.exports = exports.default;